import { render, staticRenderFns } from "./DetalleTarea.vue?vue&type=template&id=0ff6c32a"
import script from "./DetalleTarea.vue?vue&type=script&lang=js"
export * from "./DetalleTarea.vue?vue&type=script&lang=js"
import style0 from "./DetalleTarea.vue?vue&type=style&index=0&id=0ff6c32a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports